// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__26wWG","row":"ProcedureTreatmentSummary_row__hMwr6"};